// extracted by mini-css-extract-plugin
export var closeButton = "_1g-3";
export var header = "_1g-0";
export var link = "_1g-1";
export var retryButton = "_1g-2";